import { Injectable } from '@angular/core';
import type { Toast, ToastAction } from '@catch/libs';
import { ToastType } from '@catch/libs';
import { ErrorCodes } from '../constants-service/enums/error-codes.enum';

@Injectable({
  providedIn: 'root',
})
export class ToastsService {
  toasts: Toast[] = [];
  maxToastsCount = 3;
  private nextId = 1;

  

  showToast(
    value: string,
    type: ToastType = ToastType.INFO,
    actions?: ToastAction[],
    persistent: boolean = false
  ) {
    const existingToast = this.toasts.find(
      (toast) => toast.value === value && toast.type === type
    );
    if (existingToast) {
      return;
    }
    if (this.toasts.length >= this.maxToastsCount)
      this.toasts = this.toasts.slice(
        this.toasts.length - this.maxToastsCount + 1
      );
    this.toasts.push({
      id: (this.nextId++).toString(),
      type,
      value,
      actions,
      persistent,
    });
  }

  destroyToast(toast: Toast) {
    this.toasts.splice(this.toasts.indexOf(toast), 1);
  }

  info(value: string) {
    this.showToast(value, ToastType.INFO);
  }

  warning(value: string) {
    this.showToast(value, ToastType.WARNING);
  }

  alert(value: string) {
    this.showToast(value, ToastType.ALERT);
  }

  success(value: string) {
    this.showToast(value, ToastType.SUCCESS);
  }

  update() {
    const reloadAction: ToastAction = {
      label: 'ct-library.toasts.update.reload-button',
      action: () => window.location.reload(),
    };

    this.showToast(
      'ct-library.toasts.update.message',
      ToastType.UPDATE,
      [reloadAction],
      true
    );
  }

  handleError(code: string, type: ToastType = ToastType.ALERT) {
    this.showToast(
      (ErrorCodes as any)[code] || code || ErrorCodes['General/UnknownError'],
      type
    );
  }
}
